import { atom } from "jotai/index";
import type { Message } from "../../shared/Schemas";
import { atomWithStorage } from "jotai/utils";
import { VRM } from "@pixiv/three-vrm";
import { VRMEntry } from "shared/Schemas";
import type { ReceptionByAppointmentData } from "~/utils/receptionDB.types";

type CurrentSpeaker = {
  Id: number;
  Name: string;
  Style: string;
};

export const isProcessingAtom = atom(false);
// AI処理中
export const isThinkingAtom = atom(false);
// 聞き取り中
export const isListeningAtom = atom(false);
// 文章出力中
export const isOutputTextAtom = atom(false);
// 文字起こし中
export const isTranscribingAtom = atom(true);
// 文章出力
export const outputTextAtom = atom("");
// 会話サイクル中(質問送信～音声再生完了まで)
export const isInConversationCycleAtom = atom<boolean>(false);
// 音声再生待機中
export const queueArrayAtom = atom<string[]>([]);
// 要約音声再生待機中
export const summaryQueueArrayAtom = atom<string[]>([]);
// 現在のアシスタントメッセージを蓄積
export const currentAssistantMessageAtom = atom<string>("");
// 要約処理用の完全なメッセージを蓄積（表示用とは別）
export const fullAssistantMessageAtom = atom<string>("");
export const messagesAtom = atom<Message[]>([]);
// ロード済みのVRMを保持
export const currentVRMAtom = atom<VRM | null>(null);
// export const isDarkModeAtom = atomWithStorage<boolean>(
//   "isDarkMode",  //keyを指定する
//   false  //初期値
// );
export const currentSpeakerAtom = atom<CurrentSpeaker>({
  Id: 2,
  Name: "四国めたん",
  Style: "ノーマル",
});
export const T2SEngineAtom = atomWithStorage<string>("ai-reception-T2SEngine", "VOICEVOX");

export const captureToggleAtom = atom<boolean>(false);
// export const jankenModeAtom = atom<boolean>(false);
// export const jankenAtom = atom<number>(-2);

export const animationFilePathAtom = atom<string>("");
export const vrmPathAtom = atom<string>("");
export const vrmListAtom = atom<VRMEntry[]>([]);
// characterテーブル更新後に一覧再取得を促すための更新トリガ
export const characterListVersionAtom = atom<number>(0);
export const cameraStateAtom = atom<number>(0); // 0:stop 1:check 2:start -1:error
export const pictureAtom = atom<string>("");
// export const visionModeAtom = atom<boolean>(false);
export const standbyModeAtom = atom<number>(0);
// export const connectionIdAtom = atom<string>("");
export const modelPositionAtom = atom<number[]>([0, -1.3, 0, 0]);
export const modelRotationAtom = atom<number[]>([0, 0, 0, 0]);
export const fontSizeAtom = atom<string>("medium");
export const voiceSpeedAtom = atom<number>(1.0);
export const voicePitchAtom = atom<number>(0.0);
export const voiceIntonationAtom = atom<number>(1.0);
export const volumeAtom = atomWithStorage<number>("masterVolume", 0.0);
export const isSessionAtom = atom<boolean>(false);
export const isFaceDetectionAtom = atomWithStorage<boolean>("FaceDetectionMode", true);
export const isGeneratingAtom = atom<boolean>(false);

export const threshFaceSizeAtom = atomWithStorage<number>("threshFaceSize", 100);
export const faceDistanceAtom = atomWithStorage<number>("faceDistance", 100);
export const isFaceAtom = atom<boolean>(false);
export const characterIndexAtom = atom<number>(-1);
export const languageAtom = atom<string>("ja-JP");
export const displayRotationAtom = atomWithStorage<string>("displayRotation", "0");
export const isStandbyModeAtom = atom<boolean>(true);
export const isSettingOpenAtom = atom<boolean>(false);
export const isAllLoadedAtom = atom<boolean>(false);
export const categoryAtom = atom<string>("restaurant");
export const isDispClockAtom = atomWithStorage<boolean>(
  "isDispClock",
  true // true: 表示, false: 非表示
);
// 吹き出し表示
export const isBubbleVisibleAtom = atom<boolean>(false); // true: 表示, false: 非表示

export const layoutSelectAtom = atomWithStorage<number>(
  "layoutSelect",
  0 // 0:デフォルト, 1:レイアウト1, 2:レイアウト2, 3:レイアウト3
);
// 会話中断フラグ
export const isConversationInterruptedAtom = atom<boolean>(false);
// モーダル準備完了フラグ
export const isProgressModalReadyAtom = atom(false);
// 読込中画面 初期化完了通知用
export const faceModelLoadedAtom = atom<boolean>(false);
export const model3dLoadedAtom = atom<boolean>(false);
export const motion3dLoadedAtom = atom<boolean>(false);
export const difyWarmupCompletedAtom = atom<boolean>(false);
export const voicevoxWarmupCompletedAtom = atom<boolean>(false);
export const aivisspeechWarmupCompletedAtom = atom<boolean>(false);
export const errorAtom = atom<{
  code: string | null;
  content: string | null;
  title: string | null;
}>({
  code: null,
  content: null,
  title: null,
});
export const receptionAtom = atom<ReceptionByAppointmentData | null>(null);
export const receptionCompanyIdAtom = atomWithStorage<number>("receptionCompanyId", 0);
export const receptionButtonTypeAtom = atomWithStorage<string>("receptionButtonType", "");
export const isReceptionAtom = atom<boolean>(false);
